(ns manage.ad-variant-preview.widgets.loading-spinner
  (:require ["src/svg/artwork/retro-tv.svg$default" :as RetroTV]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [uix.core :as uix :refer [$ defui]]))

(defui loading-spinner [{:keys [width height]}]
  ($ empty-state-view
     {:artwork RetroTV
      :title "Rendering in progress"
      :description "The preview will become available as soon as the render is complete."
      :sx #js {:width width
               :minHeight height
               :py 2}}))
